{
  "library": {
    "header": "Library",
    "noDocumentsFound": "No documents found",
    "filterByTitlePlaceholder": "Filter by title...",
    "columns": "Columns",
    "rememberFilters": "Remember filters",
    "noResults": "No results.",
    "filters": {
      "before": "Before",
      "after": "After",
      "invalidDateRange": "After date must be before or equal to Before date",
      "isBefore": "is before",
      "isAfter": "is after",
      "isBetween": "is between",
      "equals": "is",
      "includes": "is one of",
      "notSet": "not set",
      "nullLabel": {
        "adoptedAt": "Not adopted",
        "reviewFrom": "No review from",
        "reviewTo": "No review to"
      }
    },
    "onboardDocuments": {
      "header": "Onboard documents",
      "subtitle": "Follow the guide to onboard your documents to North House",
      "leaveAlert": {
        "title": "Documents not published",
        "stay": "Stay",
        "leave": "Leave anyway",
        "draftsDescription": "Your documents are created as drafts but not published yet. Continue to the next step to publish them and finish onboarding.",
        "publishDescription": "Your documents are not published yet. Complete the onboarding to publish them."
      },
      "steps": {
        "createDrafts": {
          "title": "Create drafts",
          "description": "Upload your documents and place each in a category and tier",
          "cardTitle": "Set title, tier, and category",
          "cardDescription": "Configure the core metadata for each uploaded document. This can be changed later.",
          "requiredField": "Required field",
          "create": "Create document",
          "created": "Created",
          "createdLabel": "{{createdCount}} / {{totalCount}} created",
          "createCount": "Create {{count}} selected",
          "next": "Next",
          "clickOrDrag": "Click or drag files to upload",
          "addMore": "Add more files",
          "duplicateFiles": "Already uploaded files were skipped",
          "unsupportedType": "\"{{name}}\" has an unsupported file type",
          "fileTooLarge": "\"{{name}}\" exceeds the 50 MB size limit",
          "clearSelected": "Remove {{count}} selected",
          "duplicateWarning": "A non-archived document with this title already exists in this category.",
          "failedToCreate": "Failed to create.",
          "removeRow": "Remove row",
          "toasts": {
            "createdSome": "Created {{count}} document(s)",
            "failedSome": "{{count}} document(s) failed to create"
          }
        },
        "configureAndPublish": {
          "title": "Review and finish",
          "description": "Publish documents and finish onboarding",
          "cardTitle": "Review document details",
          "cardDescription": "Edit document metadata and publish the documents",
          "completeOnboarding": "Complete onboarding",
          "goToLibrary": "Go to library",
          "onboardMore": "Onboard more documents",
          "toasts": {
            "recurringReviewUpdated": "Updated recurring review for {{count}} document(s)",
            "failedRecurringReview": "Failed to update recurring review for {{count}} document(s)",
            "published": "Published {{count}} document(s)",
            "failedPublish": "Failed to publish {{count}} document(s)"
          }
        }
      }
    }
  }
}
